import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";

import Spinner from "./shared/Spinner";
import PrivateRoute from "./PrivateRoute";

const Connectclts = lazy(() => import("./user-pages/Connectclts"));
const Home = lazy(() => import("./user-pages/Home"));
const Connectemp = lazy(() => import("./user-pages/Connectemp"));
const Fenmenu = lazy(() => import("./user-pages/Fenmenu"));
const Empwork = lazy(() => import("./user-pages/Empwork"));
const Tabsuiclients = lazy(() => import("./user-pages/Tabsuiclients"));
const Empctrlwork = lazy(() => import("./user-pages/Empctrlwork"));

const Dashboard = lazy(() => import("./dashboard/Dashboard"));

const Buttons = lazy(() => import("./basic-ui/Buttons"));
const Dropdowns = lazy(() => import("./basic-ui/Dropdowns"));
const Typography = lazy(() => import("./basic-ui/Typography"));

const BasicElements = lazy(() => import("./form-elements/BasicElements"));

const BasicTable = lazy(() => import("./tables/BasicTable"));

const Mdi = lazy(() => import("./icons/Mdi"));
const NewGroupe = lazy(() => import("./utilisateurs/NewGroupe"));

const ChartJs = lazy(() => import("./charts/ChartJs"));

const Error404 = lazy(() => import("./error-pages/Error404"));
const Error500 = lazy(() => import("./error-pages/Error500"));

//const Login = lazy(() => import("./user-pages/Login"));
const Register1 = lazy(() => import("./user-pages/Login2"));
const Lockscreen = lazy(() => import("./user-pages/Lockscreen"));

const BlankPage = lazy(() => import("./general-pages/BlankPage"));

//parametrage des menus

const Newcompetition = lazy(() => import("./competitions/Newcompetition"));
const Newengagement = lazy(() => import("./competitions/Newengagement"));
const Newengaths = lazy(() => import("./suivi-rencontre/Newengaths"));
const Newsanction = lazy(() => import("./sanctions/Newsanction"));
const Newdiscipline = lazy(() => import("./discplines/Newdiscipline"));
const Newsdiscipline = lazy(() => import("./discplines/Newsdiscipline"));
const Newcompcompose = lazy(() => import("./competitions/Newcompcompose"));
//const Newsuser = lazy(() => import("./user-pages/CreateUserForm"));
const Login = lazy(() => import("./user-pages/Login"));
const UpdateGroupe = lazy(() => import("./utilisateurs/UpdateGroupe"));
const Updateutilisateurs = lazy(
  () => import("./utilisateurs/Updateutilisateurs"),
);
const NewUptilisateurs = lazy(
  () => import("./utilisateurs/NewUptilisateurs"),
);

const Newsuser = lazy(() => import("./utilisateurs/Newutilisateurs"));
const Newrencontre = lazy(() => import("./rencontres/Newrencontre"));
const Lancerencontre = lazy(() => import("./rencontres/Lancerencontre"));
const Suivirencontre = lazy(() => import("./rencontres/Suivirencontre"));
const Dashboard2 = lazy(() => import("./dashboard/Dashboard2"));
const NewCaisses = lazy(() => import("./caisses/NewCaisses"));
const OpeningCaisses = lazy(() => import("./caisses/OpeningCaisses"));
const ClosingCaisses = lazy(() => import("./caisses/ClosingCaisses"));
const ValDailySalary = lazy(() => import("./braiderpay/ValDailySalary"));
const PrintPaySlip = lazy(() => import("./braiderpay/PrintPaySlip"));
const ViewBlackList = lazy(() => import("./consultations/ViewBlackList"));
const ViewClients = lazy(() => import("./consultations/ViewClients"));
const ViewTresseuses = lazy(() => import("./consultations/ViewTresseuses"));
const ViewProduits = lazy(() => import("./produits/ViewProduits"));
const ViewEmploye = lazy(() => import("./tresseuses/ViewEmploye"));
const ViewClientslist = lazy(() => import("./clients/ViewClientslist"));
const InfoSupAdm = lazy(() => import("./utilisateurs/InfoSupAdm"));
const NwBlacklists = lazy(() => import("./clients/NwBlacklists"));

function AppRoutes() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route
          path="/competitions/Newcompetition"
          element={
            <PrivateRoute permissionId={5}>
              <Newcompetition />
            </PrivateRoute>
          }
        />
        <Route
          path="/utilisateurs/NewGroupe"
          element={
            <PrivateRoute permissionId={18}>
              <NewGroupe />
            </PrivateRoute>
          }
        />
        <Route
          path="/updategrp"
          element={
            <PrivateRoute permissionId={19}>
              <UpdateGroupe />
            </PrivateRoute>
          }
        />
        <Route
          path="/updateusers"
          element={
            <PrivateRoute permissionId={22}>
              <Updateutilisateurs />
            </PrivateRoute>
          }
        />
         <Route
          path="/nwupdateusers"
          element={
            <PrivateRoute permissionId={21}>
              <NewUptilisateurs />
            </PrivateRoute>
          }
        />
        <Route
          path="/nwuser"
          element={
            <PrivateRoute permissionId={20}>
              <Newsuser />
            </PrivateRoute>
          }
        />
        <Route
          path="/new_eng"
          element={
            <PrivateRoute permissionId={7}>
              <Newengagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/engnw"
          element={
            <PrivateRoute permissionId={355}>
              <Newengaths />
            </PrivateRoute>
          }
        />
        <Route
          path="/sancnw"
          element={
            <PrivateRoute permissionId={355}>
              <Newsanction />
            </PrivateRoute>
          }
        />
        <Route
          path="/discnw"
          element={
            <PrivateRoute permissionId={355}>
              <Newdiscipline />
            </PrivateRoute>
          }
        />
        <Route
          path="/nwsdisc"
          element={
            <PrivateRoute permissionId={355}>
              <Newsdiscipline />
            </PrivateRoute>
          }
        />

        <Route
          path="/nwcomcomp"
          element={
            <PrivateRoute permissionId={6}>
              <Newcompcompose />
            </PrivateRoute>
          }
        />
        <Route
          path="/nwmaths"
          element={
            <PrivateRoute permissionId={13}>
              <Newrencontre />
            </PrivateRoute>
          }
        />
        <Route
          path="/lancerencontre"
          element={
            <PrivateRoute permissionId={14}>
              <Lancerencontre />
            </PrivateRoute>
          }
        />
        <Route
          path="/suirencontre"
          element={
            <PrivateRoute permissionId={16}>
              <Suivirencontre />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute permissionId={3}>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/menp"
          element={
            <PrivateRoute permissionId={1}>
              <Fenmenu />
            </PrivateRoute>
          }
        />

        <Route
          path="/emp"
          element={
            <PrivateRoute permissionId={16}>
              <Empwork />
            </PrivateRoute>
          }
        />
        <Route
          path="/fentb"
          element={
            <PrivateRoute permissionId={33}>
              <Tabsuiclients />
            </PrivateRoute>
          }
        />
        <Route
          path="/empc"
          element={
            <PrivateRoute permissionId={2}>
              <Empctrlwork />
            </PrivateRoute>
          }
        />
        <Route
          path="/nwsale"
          element={
            <PrivateRoute permissionId={13}>
              <NewCaisses />
            </PrivateRoute>
          }
        />
        <Route
          path="/opencais"
          element={
            <PrivateRoute permissionId={14}>
              <OpeningCaisses />
            </PrivateRoute>
          }
        />
        <Route
          path="/closecais"
          element={
            <PrivateRoute permissionId={15}>
              <ClosingCaisses />
            </PrivateRoute>
          }
        />
        <Route
          path="/valdailypay"
          element={
            <PrivateRoute permissionId={16}>
              <ValDailySalary />
            </PrivateRoute>
          }
        />
        <Route
          path="/printpayslip"
          element={
            <PrivateRoute permissionId={17}>
              <PrintPaySlip />
            </PrivateRoute>
          }
        />
        <Route
          path="/viewbllst"
          element={
            <PrivateRoute permissionId={25}>
              <ViewBlackList />
            </PrivateRoute>
          }
        />
        <Route
          path="/viewcltslists"
          element={
            <PrivateRoute permissionId={24}>
              <ViewClients />
            </PrivateRoute>
          }
        />
        <Route
          path="/viewtreswrk"
          element={
            <PrivateRoute permissionId={23}>
              <ViewTresseuses />
            </PrivateRoute>
          }
        />
        <Route
          path="/viewpdts"
          element={
            <PrivateRoute permissionId={10}>
              <ViewProduits />
            </PrivateRoute>
          }
        />
        <Route
          path="/viewbraids"
          element={
            <PrivateRoute permissionId={7}>
              <ViewEmploye />
            </PrivateRoute>
          }
        />
        <Route
          path="/viewcltslst"
          element={
            <PrivateRoute permissionId={4}>
              <ViewClientslist />
            </PrivateRoute>
          }
        />
        <Route
          path="/infoadm"
          element={
            <PrivateRoute permissionId={27}>
              <InfoSupAdm />
            </PrivateRoute>
          }
        />
        <Route
          path="/cltsblk"
          element={
            <PrivateRoute permissionId={31}>
              <NwBlacklists />
            </PrivateRoute>
          }
        />
        <Route path="/login" element={<Register1 />} />
        <Route path="/clogin" element={<Home />} />
        <Route path="/prepage" element={<Connectclts />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
